export const listGalleries = (state) => state.galleries;
